
/* Swaps obj keys for vals */
export function swapKeyWithValue(json){
  var ret = {};
  for(var key in json){
    ret[json[key]] = key;
  }
  return ret;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/* Splits weather description string; capitalizes */
export function capitalizeWeatherCode(wcode) {
  if (!wcode) return 'N/A';
  let code = wcode.split('_');
  if (code.length === 1) {
    let [c] = code
    return capitalizeFirstLetter(c);
  } else if (code.length === 2) {
    return `${capitalizeFirstLetter(code[0])} ${capitalizeFirstLetter(code[1])}`;
  } else if (code.length === 3) {
    return `${capitalizeFirstLetter(code[0])} ${capitalizeFirstLetter(code[1])} ${capitalizeFirstLetter(code[2])}`;
  }
  return wcode;
}



// WEBPACK FOOTER //
// ./src/weather/utils.js